export default {
    "company_header": "Сведения об организации",
    "header_product_warning": "Регистрируетесь в желаемом продукте GrabCAD? Зарегистрироваться отдельно в {0}",
    "label": {
        "first_name": "Имя",
        "last_name": "Фамилия",
        "name": "Имя",
        "company_name": "Название компании",
        "university_name": "Название учебного заведения",
        "role": "Роль",
        "company_size": "Размер компании",
        "phone_number": "Номер телефона",
        "printer": "У вас есть 3D-принтер?",
        "student_printer": "В вашем учебном заведении есть 3D-принтер?",
        "uses_printer_for": "С какой целью вы используете 3D-принтер?",
        "shop_owner": "Вы отвечаете за управление центром 3D-моделирования?",
        "shop_users_expected": "Сколько человек делают заказы в вашем центре?",
        "email": "Эл. почта",
        "email_confirm": "Подтвердить адрес электронной почты",
        "email_again": "Повторите ввод адреса электронной почты",
        "password": "Пароль",
        "country": "Местоположение",
				"state": "Штат/Регион",
        "password_confirm": "Подтвердите пароль",
        "password_again": "Повторите ввод пароля",
        "password_hint": "Не менее 6 символов",
        "interested_in": "Мне более интересно...",
        "industry_vertical": "Отраслевая вертикаль",
        "industry_level": "Уровень задания",
        "business_email": "Служебный адрес электронной почты",
        "business_email_confirm": "Подтвердите служебный адрес электронной почты",
        "recaptcha": "Подтвердите, что вы не робот",
        "industry_level_select": "Выберите уровень задания",
        "company_size_select": "Выберите размер",
        "industry_vertical_select": "Выберите отраслевую вертикаль"
    },
    "placeholders": {
        "name": "напр., Джон Смит",
        "first": "Имя",
        "last": "Фамилия",
        "email": "Введите адрес электронной почты",
        "email_confirm": "Повторите ввод адреса электронной почты",
        "password": "Введите пароль",
        "company_name": "Введите название компании",
        "university_name": "Введите название учебного заведения",
        "phone_number": "Введите номер телефона",
        "printer": "Выберите ответ",
        "country": "Выберите страну",
				"state": "Выберите ваш штат или регион",
        "business_email": "Введите служебный адрес электронной почты",
        "business_email_confirm": "Подтвердите служебный адрес электронной почты"
    },
    "terms": {
        "buy_now_text": "Нажимая кнопку \"Далее\", вы подтверждаете, что прочли наши",
        "workbench_text": "Нажимая кнопку \"Зарегистрироваться в Workbench\", вы подтверждаете, что прочли наши",
        "print_text": "Нажимая кнопку \"Регистрация\", вы подтверждаете, что прочли наши",
        "text": "Нажимая кнопку \"Зарегистрироваться в сообществе\", вы подтверждаете, что прочли наши",
        "link": "Условия предоставления услуг"
    },
	"software_terms": {
		"link": "Условия использования ПО"
	},
    "privacy_policy": {
        "and": "и",
        "link": "Политика конфиденциальности",
        "text": "и что вы принимаете и соглашаетесь с ними."
    },
    "actions": {
        "next": "Далее",
        "workbench_sign_up": "Зарегистрироваться в Workbench",
        "sign_up_button": "Регистрация",
        "shop_sign_up": "Запросить бесплатную пробную версию GrabCAD Shop",
        "sign_up": "Зарегистрироваться в сообществе",
        "cancel": "Отмена"
    },
    "error": {
        "name_empty": "Укажите свое имя",
        "email_taken": "Этот адрес электронной почты уже зарегистрирован. Авторизуйтесь или выберите другой адрес электронной почты.",
        "email_empty": "Укажите свой адрес электронной почты",
        "email_nomatch": "Адреса электронной почты должны совпадать",
        "email_look": "Введите действующий адрес электронной почты",
        "password_nomatch": "Пароли должны совпадать",
        "password_short": "Слишком короткий пароль. Он должен содержать не менее 6 символов.",
        "password_empty": "Введите пароль",
        "recaptcha": "Установите флажок, чтобы подтвердить, что вы не робот",
        "country_blocked": "К сожалению, вам не разрешено зарегистрироваться в GrabCAD",
        "blank": "не может быть пустым"
    },
    "active": {
        "email": "Введите действующий адрес электронной почты, на который будет отправлено сообщение с подтверждением."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "Нет, я не планирую",
            "no_but_interesed": "Нет, мне не интересно",
            "yes_for_work": "Да, для работы",
            "yes_as_hobby": "Да, только хобби",
            "yes_for_other": "Да, по другим причинам"
        },
        "student": {
            "no_dont_plan": "Нет, мое учебное заведение не заинтересовано в 3D-печати",
            "no_but_interesed": "Нет, но мое учебное заведение в настоящее время подыскивает 3D-принтер",
            "yes_they_do": "Да",
            "not_sure": "Не уверен"
        }
    },
    "uses_printer_for": {
        "professional": "Профессиональное использование",
        "education": "Образование/исследование",
        "hobby": "Хобби",
        "dont_use": "Я не использую 3D-принтер"
    },
    "level_values": {
        "administrator_principal_superintendent": "Администратор / Руководитель / Начальник",
        "biomedical_engineer": "Биомедицинский",
        "c_level_executive": "Руководство высшего звена",
        "clinical_preclinical": "Клинический / Доклинический",
        "dean_department_head": "Декан / Кафедра",
        "dentist": "Стоматолог",
        "designer": "Дизайнер",
        "educator": "Педагог",
        "engineer": "Инженер",
        "equipment_manufacturer": "Производитель оборудования",
        "lab_owner": "Владелец лаборатории",
        "lab_technician": "Лаборант",
        "marketing": "Маркетинг",
        "medical_education_and_training": "Медицинское образование и обучение",
        "parent": "Родитель",
        "practicing_physician": "Практикующий врач",
        "president_provost": "Президент / Проректор",
        "prosthetist_orthotist": "Протезист / Ортопед",
        "purchasing": "Покупка",
        "quality": "Качество",
        "rd_engineering": "НИОКР / Проектирование",
        "sales": "Продажи",
        "senior_management_administration": "Высшее руководство / Администрация",
        "student": "Студент",
        "training": "Подготовка",
        "other": "Прочее",
        "not_employed": "Не работаю"
    },
    "industry_values": {
        "aerospace": "Аэрокосмическая промышленность",
        "architecture": "Архитектура",
        "arts_entertainment": "Искусство и развлечения",
        "automotive": "Автомобилестроение",
        "commercial_products": "Серийный выпуск изделий",
        "consumer_electronics": "Бытовая техника",
        "consumer_goods": "Потребительские товары",
        "dental": "Стоматология",
        "education": "Образование",
        "engineering_consulting_service": "Инженерный консалтинг",
        "government_military": "Правительственные учреждения / Вооруженные силы",
        "industrial_equipment": "Промышленное оборудование",
        "jewelry": "Ювелирные изделия",
        "medical_device": "Медицинские устройства или оборудование",
        "service_bureau": "Бюро обслуживания",
        "toys": "Игрушки",
        "reseller": "Перепродавец",
        "other": "Прочее"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "Не компания"
    },
    "yes_no_values": {
        "yes": "Да",
        "no": "Нет"
    }
}
